import { createField } from "./requestor.section";

export const initForm = ({ props, data, refs }) => {
    data.fields = createField({ props, data, refs, key: props.dataKey, isLoading: props.isLoading });
};
